import { RouteConfig } from 'vue-router';
import InstagramCodeReceiver from '@/views/instagram/InstagramCodeReceiver.vue';

export default (): RouteConfig => ({
  path: '/instagram/code',
  name: 'InstagramCodeReceiver',
  component: InstagramCodeReceiver,
});
